(function __mod(){
/* TBO Oct 18 2026 - Subscribe & save offer on cart lines.
   Card quick-add, search add and one-time PDP adds land as one-time purchases.
   For any cart line whose product has Recharge selling plans and no plan yet,
   show a one-tap switch to the default plan (6 weeks if offered). Uses native
   selling plans via /cart/change.js so checkout stays Shopify native.
   Never blocks checkout; any failure just leaves the line one-time. */
'use strict';
if (window.__tboSubUpsell) return; window.__tboSubUpsell = true;
var DOT = ' ' + String.fromCharCode(183) + ' ';
var cache = {};
var busy = false;
function getProduct(handle) {
  if (!cache[handle]) cache[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  return cache[handle];
}
function pickPlan(p) {
  var plans = [];
  (p.selling_plan_groups || []).forEach(function (g) { (g.selling_plans || []).forEach(function (s) { plans.push(s); }); });
  if (!plans.length) return null;
  for (var i = 0; i < plans.length; i++) { if (/6 week/i.test(plans[i].name)) return plans[i]; }
  return plans[0];
}
function pct(plan) {
  var a = plan.price_adjustments && plan.price_adjustments[0];
  return a && a.value_type === 'percentage' ? a.value : null;
}
function style() {
  if (document.getElementById('tbo-sub-offer-css')) return;
  var s = document.createElement('style'); s.id = 'tbo-sub-offer-css';
  s.textContent = '.tbo-sub-offer{display:inline-block;margin-top:8px;padding:6px 12px;border:1px solid #c8102e;border-radius:999px;background:#fff;color:#c8102e;font:inherit;font-size:1.2rem;font-weight:600;line-height:1.3;cursor:pointer;text-align:left}.tbo-sub-offer:hover{background:#c8102e;color:#fff}.tbo-sub-offer[disabled]{opacity:.6;cursor:default}';
  document.head.appendChild(s);
}
function offer(scope, row, item, plan) {
  if (row.getAttribute('data-tbo-sub') === item.key) return;
  var host = row.querySelector('.cart-item__details'); if (!host) return;
  var old = host.querySelector('.tbo-sub-offer'); if (old) old.remove();
  row.setAttribute('data-tbo-sub', item.key);
  var off = pct(plan);
  var label = 'Subscribe & save' + (off ? ' ' + off + '%' : '') + DOT + plan.name.split(',')[0].toLowerCase();
  var btn = document.createElement('button');
  btn.type = 'button'; btn.className = 'tbo-sub-offer'; btn.textContent = label;
  btn.addEventListener('click', function (e) {
    e.preventDefault(); e.stopPropagation();
    if (busy) return; busy = true; btn.disabled = true; btn.textContent = 'Switching...';
    var d = document.querySelector('cart-drawer');
    var body = { id: item.key, quantity: item.quantity, selling_plan: plan.id };
    var useDrawer = scope === 'drawer' && d && typeof d.renderContents === 'function' && typeof d.getSectionsToRender === 'function';
    if (useDrawer) { body.sections = d.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        busy = false;
        if (state.status) { btn.disabled = false; btn.textContent = label; return; }
        if (useDrawer && state.sections) { d.classList.remove('is-empty'); d.renderContents(state); }
        else { window.location.reload(); }
        document.dispatchEvent(new CustomEvent('tbo:cart:updated'));
      })
      .catch(function () { busy = false; btn.disabled = false; btn.textContent = label; });
  });
  host.appendChild(btn);
}
function decorate() {
  if (!document.getElementById('CartDrawer-Item-1') && !document.getElementById('CartItem-1')) return;
  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
    style();
    cart.items.forEach(function (item, idx) {
      if (item.selling_plan_allocation) return;
      getProduct(item.handle).then(function (p) {
        var plan = p && pickPlan(p); if (!plan) return;
        var dRow = document.getElementById('CartDrawer-Item-' + (idx + 1));
        var pRow = document.getElementById('CartItem-' + (idx + 1));
        if (dRow) offer('drawer', dRow, item, plan);
        if (pRow) offer('page', pRow, item, plan);
      });
    });
  }).catch(function () {});
}
var t = null;
function schedule() { if (t) clearTimeout(t); t = setTimeout(function () { t = null; decorate(); }, 300); }
function init() {
  var cd = document.getElementById('CartDrawer');
  if (cd) new MutationObserver(schedule).observe(cd, { childList: true });
  var mc = document.getElementById('main-cart-items');
  if (mc) new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) { var n = muts[i].target; if (!(n.closest && n.closest('.tbo-sub-offer'))) { schedule(); return; } }
  }).observe(mc, { childList: true, subtree: true });
  document.addEventListener('tbo:cart:updated', schedule);
  schedule();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
